import { SerializedFarmConfig } from '@pancakeswap/farms'
import { frenchainTokens } from '@pancakeswap/tokens'

const priceHelperLps: SerializedFarmConfig[] = [
    {
      pid: null,
      lpSymbol: 'USDC-ETH LP',
      lpAddress: '0xC6BCc019658cE2958E85d83F83Ca5Bbafe367071',
      quoteToken: frenchainTokens.usdc,
      token: frenchainTokens.eth,
    },
  ].map((p) => ({ ...p, token: p.token.serialize, quoteToken: p.quoteToken.serialize }))

export default priceHelperLps
